<template>
<div id="puzzles-by-year">
  <form
  >
    <div class="form-group">
      <label for="puzzle-year-picker">
        Get Puzzles by Year
      </label>

      <select
        id="puzzle-year-picker"
        name="year"
        class="form-control"
        v-model="year"
      >
        <option disabled value="" selected="selected">Pick a Year</option>
        <option v-for="year in archivedYears">
          {{ year }}
        </option>
      </select>
    </div>

    <div v-if="year">
      <h3>
        Puzzles From {{ year }}
      </h3>

      <pagination
        :resourceUrl="resourceUrl"
        :pageSize="$root.defaultPageSize"
        orderBy="date"
        orderType="DESC"
        v-if="resourceUrl"
      >
        <template
          slot="paged_item"
          slot-scope="item"
        >
          <puzzle-list :puzzle="item" />
        </template>
      </pagination>
    </div>
  </form>
</div>
</template>

<script>
import PuzzleListItem from '@/components/PuzzleListItem'

import Pagination from 'sai-vue-kaminari'

export default {
  data () {
    return {
      resourceUrl: undefined,
      year: undefined
    }
  },

  components: {
    'pagination': Pagination,
    'puzzle-list': PuzzleListItem
  },

  computed: {
    archivedYears () {
      let startYear = 2006
      let archived = []
      const thisYear = this.currentYear

      while (startYear <= thisYear) {
        archived.unshift(startYear)
        startYear = startYear + 1
      }

      return archived
    },

    currentYear () {
      return new Date().getYear() + 1900
    }
  },

  props: ['yearId'],

  created () {
    this.year = this.yearId || this.currentYear
  },

  watch: {
    year () {
      this.resourceUrl = this.apiUrl(
        '/admin/puzzles/' + this.year + '/puzzles_by_year?page[order_by]=date&page[order_type]=DESC'
      )
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PuzzlesByYear.vue